module.exports = __webpack_public_path__ + "static/media/blueCalendar.c5eac7d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueCalendar.svg
// module id = 448
// module chunks = 0